import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B, tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Track as Track_1, toastServerError, Task } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { ContextMsg, useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { DialogBody, Spinner, DialogActions, Image, tokens, Caption2, CardHeader, Card, Option, Dropdown, Caption1, Text as Text$, Switch, Textarea, Input, Field, DialogContent, DialogTitle, DialogSurface, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { SaveRegular, ImageAddRegular, DismissRegular, CheckmarkCircleRegular, CheckmarkLockRegular, EditRegular } from "@fluentui/react-icons";
import { take, length, iterate, toArray, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { UpdateTrack, S3UploadFile, Track } from "../Shared/SharedModels.jsx";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { tryFind, append as append_1, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { orElse, toArray as toArray_1 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";

function getTasks(callback, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 0) {
            callback(res.fields[0]);
        }
        else {
            errorToast(setCtx, "getTasksError", "Kunne ikke hente oppgaver", "Noe gikk galt", undefined);
        }
    }, startAsPromise(Task.GetAllTasks()));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

export function UpdateTrackDialog(updateTrackDialogInputProps) {
    let elems_18, el_4, el_2, el, el_86, elems_17, props_124, el_6, el_68, elems_14, el_84, elems_16, el_74, el_72, el_70, el_82, name_14, elemsToUse;
    const callback = updateTrackDialogInputProps.callback;
    const track = updateTrackDialogInputProps.track;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(track);
    const setForm = patternInput_1[1];
    const form = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const patternInput_3 = reactApi.useState(false);
    const patternInput_4 = reactApi.useState(undefined);
    const setFile = patternInput_4[1];
    const file = patternInput_4[0];
    const patternInput_5 = reactApi.useState(track.ThumbnailUrl);
    const setImg = patternInput_5[1];
    const img = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsSending = patternInput_6[1];
    const isSending = patternInput_6[0];
    const patternInput_7 = reactApi.useState([]);
    const allTasks = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsOpen = patternInput_8[1];
    useEffectOnce(() => {
        getTasks(patternInput_7[1], setCtx);
    });
    const el_88 = Dialog;
    return createElement(el_88, createObj(ofArray([["open", patternInput_8[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        setIsOpen(value_1_1.open);
        setForm(track);
    }], (elems_18 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            size: "small",
            children: "Rediger",
            icon: (el = EditRegular, createElement(el, {})),
        })),
    })), (el_86 = DialogSurface, createElement(el_86, createObj(singleton_1((elems_17 = [(props_124 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        as: "h1",
        children: "Rediger læringsløp",
    })), (el_68 = DialogContent, createElement(el_68, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_14 = toList(delay(() => {
        let elems_1, el_11;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            height: 70,
        }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(patternInput_2[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => append(singleton(["label", "Navn"]), delay(() => {
            let matchValue, el_8;
            return singleton(["children", (matchValue = tryHead([(el_8 = Input, createElement(el_8, {
                value: form.Name,
                placeholder: "ADHD barn 4-6 år",
                onChange: (_arg_2, value_1_11) => {
                    const v = value_1_11;
                    setForm(new Track(form.Id, v.value, form.Description, form.Enabled, form.ImageUrl, form.ThumbnailUrl, form.Inserted, form.TrackLevels, form.ReactivationTasks));
                    patternInput_2[1](isNullOrWhiteSpace(v.value));
                },
            }))]), (matchValue == null) ? defaultOf() : matchValue)]);
        })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_3, el_16;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                height: 100,
            }], (elems_3 = [(el_16 = Field, createElement(el_16, createObj(toList(delay(() => append(singleton(["label", "Beskrivelse"]), delay(() => append(patternInput_3[0] ? append(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : ((form.Description.length > 5000) ? append(singleton(["validationMessage", `Beskrivelse kan ikke være lengre enn 5000 tegn (${form.Description.length}/5000)`]), delay(() => singleton(["validationState", "error"]))) : append(singleton(["validationMessage", `${form.Description.length}/5000`]), delay(() => singleton(["validationState", "none"])))), delay(() => {
                let matchValue_1, el_13;
                return singleton(["children", (matchValue_1 = tryHead([(el_13 = Textarea, createElement(el_13, {
                    style: {
                        height: 70,
                    },
                    value: form.Description,
                    onChange: (_arg_3, value_1_17) => {
                        const v_1 = value_1_17;
                        setForm(new Track(form.Id, form.Name, v_1.value, form.Enabled, form.ImageUrl, form.ThumbnailUrl, form.Inserted, form.TrackLevels, form.ReactivationTasks));
                        patternInput_3[1](isNullOrWhiteSpace(v_1.value));
                    },
                }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_5, el_21, matchValue_2, el_18;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    height: 100,
                }], (elems_5 = [(el_21 = Field, createElement(el_21, {
                    label: "Publiser",
                    hint: "Publiser for å gjøre læringsløpet tilgjengelig for alle",
                    children: (matchValue_2 = tryHead([(el_18 = Switch, createElement(el_18, {
                        checked: form.Enabled,
                        onChange: (ev) => {
                            setForm(new Track(form.Id, form.Name, form.Description, ev.target.checked, form.ImageUrl, form.ThumbnailUrl, form.Inserted, form.TrackLevels, form.ReactivationTasks));
                        },
                    }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                    let elems_10;
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 5 + "px ",
                    }], (elems_10 = toList(delay(() => {
                        let el_23;
                        return append(singleton((el_23 = Text$, createElement(el_23, {
                            children: "Oppgaver for reaktivering",
                        }))), delay(() => {
                            let el_25;
                            return append(singleton((el_25 = Caption1, createElement(el_25, {
                                children: "Oppgaver som kreves gjennomført på nytt etter læringsløp er blitt inaktivt for en bruker",
                            }))), delay(() => {
                                let el_34, matchValue_3, el_31, elems_7;
                                return append(singleton((el_34 = Field, createElement(el_34, {
                                    label: "Legg til eksisterende oppgaver",
                                    children: (matchValue_3 = tryHead([(el_31 = Dropdown, createElement(el_31, createObj(ofArray([["appearance", "filled-darker"], ["style", {
                                        minWidth: 250,
                                        width: 250,
                                    }], ["selectedOptions", toArray(map((_arg_4) => _arg_4.Name, form.ReactivationTasks))], ["onOptionSelect", (_arg_5, value_1_23) => {
                                        iterate((optText) => {
                                            iterate((foundTask) => {
                                                setForm(new Track(form.Id, form.Name, form.Description, form.Enabled, form.ImageUrl, form.ThumbnailUrl, form.Inserted, form.TrackLevels, append_1([foundTask], form.ReactivationTasks)));
                                            }, toArray_1(tryFind((task) => (task.Name === optText), allTasks)));
                                        }, toArray_1(value_1_23.optionText));
                                    }], (elems_7 = toList(delay(() => map((t) => {
                                        let elems_6, el_27;
                                        const el_29 = Option;
                                        return createElement(el_29, createObj(ofArray([["disabled", form.ReactivationTasks.some((s) => (s.Id === t.Id))], ["value", t.Name], ["text", t.Name], (elems_6 = [(el_27 = Text$, createElement(el_27, {
                                            children: t.Name,
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])));
                                    }, allTasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))]), (matchValue_3 == null) ? defaultOf() : matchValue_3),
                                }))), delay(() => map((task_1) => {
                                    let elems_9, el_48, el_36, el_38, el_40, el_42, el_46, el_44;
                                    const el_50 = Card;
                                    return createElement(el_50, createObj(ofArray([["style", {
                                        minHeight: 50,
                                    }], ["size", "small"], ["appearance", "filled-alternative"], (elems_9 = [(el_48 = CardHeader, createElement(el_48, {
                                        header: (el_36 = Caption1, createElement(el_36, {
                                            children: task_1.Name,
                                        })),
                                        description: (el_38 = Caption2, createElement(el_38, {
                                            children: task_1.Description,
                                        })),
                                        image: task_1.VerificationRequired ? ((el_40 = CheckmarkLockRegular, createElement(el_40, {
                                            fontSize: 20,
                                            primaryFill: tokens.colorStatusSuccessForeground1,
                                        }))) : ((el_42 = CheckmarkCircleRegular, createElement(el_42, {
                                            fontSize: 20,
                                            primaryFill: tokens.colorStatusSuccessForeground1,
                                        }))),
                                        action: (el_46 = Button, createElement(el_46, {
                                            onClick: (_arg_6) => {
                                                setForm(new Track(form.Id, form.Name, form.Description, form.Enabled, form.ImageUrl, form.ThumbnailUrl, form.Inserted, form.TrackLevels, form.ReactivationTasks.filter((r) => (r.Id !== task_1.Id))));
                                            },
                                            appearance: "transparent",
                                            style: {
                                                padding: 0,
                                                borderWidth: 0,
                                            },
                                            icon: (el_44 = DismissRegular, createElement(el_44, {
                                                style: {
                                                    padding: 0,
                                                },
                                                fontSize: 16,
                                            })),
                                        })),
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])));
                                }, form.ReactivationTasks)));
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => append(singleton(createElement("input", {
                        id: "image-select-input-edit-track",
                        type: "file",
                        accept: "image/png, image/jpeg",
                        onChange: (ev_1) => {
                            const files = ev_1.target.files;
                            if (!(files == null) && (files.length > 0)) {
                                const f = files.item(0);
                                const reader = new FileReader();
                                reader.onload = ((_arg_7) => {
                                    const matchValue_4 = reader.result;
                                    if (typeof matchValue_4 === "string") {
                                        const base64data = matchValue_4;
                                        setFile(f);
                                        setImg(base64data);
                                    }
                                });
                                reader.readAsDataURL(f);
                            }
                        },
                        style: {
                            display: "none",
                        },
                    })), delay(() => {
                        let el_52, el_66, elems_13, el_64, el_58;
                        let matchResult, i;
                        if (file != null) {
                            if (img != null) {
                                matchResult = 0;
                                i = img;
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0:
                                return append(singleton((el_52 = Image, createElement(el_52, {
                                    style: {
                                        width: 100 + "%",
                                        maxHeight: 250,
                                        minHeight: 150,
                                    },
                                    fit: "contain",
                                    src: i,
                                }))), delay(() => {
                                    let elems_11, el_56, el_54;
                                    return singleton(createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        width: 100 + "%",
                                        justifyContent: "center",
                                    }], (elems_11 = [(el_56 = Button, createElement(el_56, {
                                        children: "Slett bilde",
                                        size: "small",
                                        onClick: (_arg_8) => {
                                            setFile(undefined);
                                            setImg(undefined);
                                        },
                                        icon: (el_54 = DismissRegular, createElement(el_54, {})),
                                        appearance: "outline",
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                                }));
                            default: {
                                const matchValue_6 = orElse(form.ThumbnailUrl, form.ImageUrl);
                                if (matchValue_6 == null) {
                                    return singleton((el_66 = Button, createElement(el_66, createObj(ofArray([["onClick", (_arg_10) => {
                                        document.getElementById("image-select-input-edit-track").click();
                                    }], ["style", {
                                        width: 100 + "%",
                                        maxHeight: 250,
                                        minHeight: 150,
                                        borderStyle: "dashed",
                                        borderColor: tokens.colorBrandBackgroundStatic,
                                        borderWidth: 1,
                                    }], (elems_13 = [(el_64 = ImageAddRegular, createElement(el_64, {
                                        fontSize: 48,
                                        primaryFill: tokens.colorBrandForeground2,
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])])))));
                                }
                                else {
                                    const url = matchValue_6;
                                    return append(singleton((el_58 = Image, createElement(el_58, {
                                        style: {
                                            width: 100 + "%",
                                            maxHeight: 250,
                                            minHeight: 150,
                                        },
                                        fit: "contain",
                                        src: url,
                                    }))), delay(() => {
                                        let elems_12, el_62, el_60;
                                        return singleton(createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            width: 100 + "%",
                                            justifyContent: "center",
                                        }], (elems_12 = [(el_62 = Button, createElement(el_62, {
                                            children: "Slett bilde",
                                            size: "small",
                                            onClick: (_arg_9) => {
                                                setForm(new Track(form.Id, form.Name, form.Description, form.Enabled, undefined, undefined, form.Inserted, form.TrackLevels, form.ReactivationTasks));
                                            },
                                            icon: (el_60 = DismissRegular, createElement(el_60, {})),
                                            appearance: "outline",
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
                                    }));
                                }
                            }
                        }
                    }))));
                }));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_14))])])))), (el_84 = DialogActions, createElement(el_84, createObj(ofArray([["position", "end"], (elems_16 = [(el_74 = DialogTrigger, createElement(el_74, {
        disableButtonEnhancement: true,
        children: (el_72 = Button, createElement(el_72, {
            disabled: isSending,
            icon: (el_70 = DismissRegular, createElement(el_70, {})),
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_82 = Button, createElement(el_82, createObj(toList(delay(() => append(singleton(["disabled", (((equals(form, track) ? true : isSending) ? true : isNullOrWhiteSpace(form.Name)) ? true : isNullOrWhiteSpace(form.Description)) ? true : (form.Description.length > 5000)]), delay(() => {
        let el_76;
        return append(!isSending ? singleton(["icon", (el_76 = SaveRegular, createElement(el_76, {}))]) : empty(), delay(() => append(singleton(["appearance", "primary"]), delay(() => append(singleton(["onClick", (_arg_11) => {
            setIsSending(true);
            const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let file_1;
                return ((file_1 = file, PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    if (file_1 != null) {
                        const f_1 = file_1;
                        return startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_12) => {
                            let res;
                            const MimeType = f_1.type;
                            res = (new S3UploadFile(f_1.name, MimeType, _arg_12));
                            return Promise.resolve(res);
                        });
                    }
                    else {
                        return Promise.resolve(undefined);
                    }
                })))).then((_arg_13) => {
                    let pr_1;
                    const pr = startAsPromise(Track_1.Update(new UpdateTrack(form, _arg_13)));
                    pr_1 = (pr.then((res_1) => {
                        let tupledArg;
                        if (res_1.tag === 1) {
                            if (res_1.fields[0].tag === 1) {
                                errorToast(setCtx, "updateTrackErrorNotFound", "Kunne ikke redigere læringsløp", "Fant ikke læringsløp", undefined);
                                setIsSending(false);
                            }
                            else {
                                errorToast(setCtx, "updateTrackErrorConflict", "Kunne ikke redigere læringsløp", "", undefined);
                                setIsSending(false);
                            }
                        }
                        else {
                            const track_1 = res_1.fields[0];
                            setIsSending(false);
                            callback(track_1);
                            setIsOpen(false);
                            setCtx((tupledArg = [track_1.Id, track_1.Name], new ContextMsg(8, [tupledArg[0], tupledArg[1]])));
                            successToast(setCtx, `updateTrackSuccess${track_1.Id}`, "Læringsløp endret", "");
                        }
                    }));
                    void (pr_1.catch((ex) => {
                        setIsSending(false);
                        toastServerError(setCtx, ex);
                    }));
                    return Promise.resolve();
                });
            }));
            void pr_2;
        }]), delay(() => {
            let elems_15;
            return singleton((elems_15 = toList(delay(() => {
                let el_78, el_80;
                return isSending ? singleton((el_78 = Spinner, createElement(el_78, {
                    size: "tiny",
                }))) : singleton((el_80 = Text$, createElement(el_80, {
                    children: "Lagre",
                })));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_15))]));
        }))))));
    })))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))])]))))]), (name_14 = DialogBody, createElement(name_14, {
        children: reactApi.Children.toArray(Array.from(props_124)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_17))])))))], (elemsToUse = ((length(elems_18) <= 2) ? elems_18 : take(2, elems_18)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=EditTrack.jsx.map
